<!-- Merchant Services Container -->
<div class="container-fluid full-width">

  <div class="top-cont">
    <div class="business-services__container_pay">
      <div class="payment-services__inner-div_bus cus-bnd">
        <ul class="breadcrumb">
          <li class="breadcrumb-item "><a href="/business-services/">Business Services</a></li>
          <li><a class="unselected-breadcrumb">Merchant Services</a></li>
        </ul>
        <span>
          <h3 class="payment-services__inner-div--heading_bus">Merchant Services</h3><br>
          <hr class="payment-services__hr_bus">
        </span>
        <div class="payment-services__inner-div--content bus_wor0">
          Accept card payments the way your customers want, wherever business happens.

        </div>

        <div class="hero-panel-button bus_btn">
          <a href="https://pages.paymentsolutions.chase.com/UPSC.html" target="_blank" class="get-secret-btn"
            tabindex="-1" rel="noopener">
            Get Started
            <img class="arrow-head-left" src="../../../../assets/redesignImages/button-menu.png"></a>
        </div>
      </div>
      <img class="business-services__image_bus" alt="Business-services-img" src="../../../../assets/redesignImages/Content1.png" width="535"
        height="332">
    </div>
    <img class="media-margin-value" src="../../../../assets/redesignImages/Vector.png">
  </div>
  <!-- UL container -->

  <h2 class="simplified-shipping__inner-container">
    Secure and Affordable Payment Solutions
  </h2>
  <hr class="simplified-shipping__hr">
  <p class="simplified-shipping__inner-second-container">
    UPS Capital teams up with Chase to offer a simple and secure payment experience.
  </p>


  <div class="row g-0 cont-bg1">
    <div class="col ic-grp ">
      <div class="text-center  img-tag">
        <img class="rounded mx-auto d-block ico-img" src="../../../../assets/redesignImages/add_card.png" />
      </div>

      <div class="wrapper">

        <p class="tit-0 maj">At the Counter</p>
        <p class="tit-0 sml">Accept debit cards, credit cards and mobile wallets.
        </p>
      </div>

    </div>
    <div class="col ic-grp">
      <div class="text-center img-tag">
        <img class="ico-img rounded mx-auto d-block" src="../../../../assets/redesignImages/affordablepayment2.png" />
      </div>
      <div class="wrapper">
        <p class="tit-0 maj ">Website</p>
        <p class="tit-0 sml">Offer customers an easy and secure way to pay online.
        </p>
      </div>
    </div>
    <div class="col ic-grp ">
      <div class="text-center img-tag">
        <img class="ico-img rounded mx-auto d-block" src="../../../../assets/redesignImages/affordablepayment3.png" />
      </div>
      <div class="wrapper">
        <p class="tit-0 maj">Mobile Device</p>
        <p class="tit-0 sml">Let your customers pay whenever, wherever on the go.</p>
      </div>
    </div>
  </div>

  <!-- Benefits That Won’t Break the Bank Container -->

  <h2 class="simplified-shipping__inner-container1">
    Benefits That Won’t Break the Bank
  </h2>
  <hr class="simplified-shipping__hr">

  <div class="card-container">

    <div class="card fl0">
      <div class="card-img imgbn0">
        <img class="img-fluid" src="../../../../assets/redesignImages/BenefitsImg.png" />

      </div>
      <div class="card-body crB01">
        <div class="card-body-content">
          <ul class="ul-container-list">
            <li class="li-container-list">Receive clear pricing with competitive rates and no hidden fees.
            </li>
            <li class="li-container-list">Start without up-front fees and long-term contracts<sup
                class="media-sup-values">1</sup>.
            </li>
            <li class="li-container-list">Meet industry security standards without added costs.
            </li>
            <li class="li-container-list">Get next-business-day funding<sup class="sup-new">2</sup> to
              shorten your cash conversion cycle.
            </li>
            <li class="li-container-list">Run transactions reports and reprint receipts.</li>
            <li class="li-container-list">Access 24/7 live customer support whenever you need it.</li>
            <div class="home-btn01 new-complete-button">
              <a class="get-secret-btn width-new home-btn02" tabindex="-1"
                href="https://pages.paymentsolutions.chase.com/UPSC.html" target="_blank" rel="noopener">Complete
                Application <img class="arrow-head-left" src="../../../../assets/redesignImages/button-menu.png"></a>
            </div>


          </ul>


        </div>
      </div>
    </div>

  </div>
  <br>
  <div class="card-bus card-container">

    <div class="card fl0">

      <div class="card-header BsHead">
        <h2 class="sub-title">Power Up Your <br>Payment Options</h2>
      </div>
      <div class="card-img BsImage ">
        <img class="img-fluid" src="../../../../assets/redesignImages/Content-3.png" />

      </div>
      <div class="card-body BsBody crB02">
        <div class="card-body-content">
          <p class="sub-cont0">Offer your customers additional ways to pay, such as recurring billing, gift
            cards,
            e-checks, loyalty programs and contactless payments.</p>

          <div class="home-btn01">
            <a class="get-secret-btn home-btn02 width-new1" tabindex="-1"
              href="https://pages.paymentsolutions.chase.com/UPSC.html" target="_blank" rel="noopener">Sign Up <img
                class="arrow-head-left" src="../../../../assets/redesignImages/button-menu.png"></a>
          </div>

        </div>
      </div>
    </div>

  </div>
  <br class="no-display-br">
  <br class="no-display-br">

  <div class="col-md-12 para-com">
    <p class="bot-para">
      Businesses are required to complete an application and agree to terms and conditions at the time of
      enrollment.
      All
      businesses are subject to credit approval. Merchant services are provided by Paymentech, LLC (“Chase”), a
      subsidiary
      of JPMorgan Chase Bank, N.A. Member FDIC.
    </p>
    <p></p>
    <p></p>
    <p class="bot-para">
      <sup class="bot-sp">1</sup> Certain restrictions may apply. Not all businesses may qualify for
      Month-to-month or
      No Long-Term Contract, such
      as businesses which: require processing capabilities in multiple currencies, process over $5 million in
      annual
      credit/debit card sales or have certain software or connectivity requirements. Qualifying businesses may
      terminate
      their contract at any time by providing 30 days’ written notice. Businesses who receive a promotional
      consideration
      from Chase may be required to repay all or a pro-rated portion of the value of such promotional
      consideration if
      the
      contract is terminated within the first 24 months. Businesses which do not qualify for the No Long-Term
      Contract
      may
      be subject to additional terms and conditions, including a defined initial term and early termination fees.
      Talk
      to
      a Chase Representative for more details at <a class="no-footer">888-234-8913</a>.
    </p>
    <p></p>
    <p></p>
    <p class="bot-para">
      <sup class="bot-sp">2</sup> Next business day funding is available to eligible Chase merchant services
      clients
      who deposit into a single Chase
      business checking account. Visa®, MasterCard®, and Discover® credit and debit transactions are eligible. All
      businesses are subject to business credit approval and all funds are subject to fraud monitoring. In
      addition,
      funding is subject to the terms and conditions of the merchant processing agreement. Chase must receive
      settled
      transactions by 10:00 pm ET (some businesses may qualify for a 11:59 pm ET settlement; talk to a Chase
      representative for more details). Funds are deposited on the next business day, excluding weekends and bank
      holidays. Some exclusions may apply. The listed payment brand(s) are not sponsors of this program. All marks
      are
      marks of their respective companies. Deposit products provided by JPMorgan Chase Bank, N.A. Member FDIC.
    </p>
  </div>
</div>